module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Subscription","tariff":"Subscription plan","change":"Change","currency":{"RUB":"RUB"},"expire":"Will expire {date}","neverExpire":"Never expire","nextPayment":"Next payment {date}","subscription":{"upgrade":"Улучшить","cancel":"Отменить","cancelled":"Подписка отменена"},"card":{"title":"","change":""}}}')
  delete Component.options._Ctor
}
